import { Link } from 'react-scroll';
import './NavBar.css';

function NavBar() {
    return (
        <div className="navbar-container">
            <Link to="about" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    Yunsik Lee
                </button>
            </Link>
            <Link to="about" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    About
                </button>
            </Link>
            <Link to="education" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    Education
                </button>
            </Link>
            <Link to="project" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    Project
                </button>
            </Link>
            <Link to="activity" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    Activity
                </button>
            </Link>
            <Link to="award" spy={true} smooth={true} duration={500} className="nav-link">
                <button className="nav-button">
                    Award
                </button>
            </Link>
        </div>
    )
}

export default NavBar;